<template>
  <main>
    <section
      class="newslater-area4 pb-120 wow fadeInDown animated login-section"
      data-animation="fadeInDown"
      data-delay=".4s"
    >
      <div class="container text-left" style="background: #fcfaf8">
        <div class="row align-items-center">
          <div class="col-xl-7 col-lg-7 col-md-12" style="margin: 0 auto">
            <div class="section-title section-title2 mb-30">
              <h2>{{ isTeacher ? 'Instructor Sign Up' : 'Student Sign Up' }}</h2>
              <p>
                {{ isTeacher 
                  ? 'Join as an instructor to share your knowledge and create courses.' 
                  : 'Sign up today to access high-quality courses and hands-on projects.' 
                }}
              </p>
            </div>

            <!-- Role Toggle -->
            <div class="role-toggle mb-30">
              <label class="toggle-label">I am a:</label>
              <div class="toggle-switch">
                <button 
                  @click="isTeacher = false" 
                  :class="{ active: !isTeacher }"
                  class="toggle-btn"
                >
                  Student
                </button>
                <button 
                  @click="isTeacher = true" 
                  :class="{ active: isTeacher }"
                  class="toggle-btn"
                >
                  Instructor
                </button>
              </div>
            </div>

            <form class="contact-form newslater mb-30" @submit.prevent="handleSignup">
              <div class="form-group" style="margin-bottom: 20px">
                <!-- First Name & Last Name -->
                <div class="d-flex" style="gap: 10px">
                  <input
                    v-model="firstName"
                    class="form-control"
                    type="text"
                    placeholder="First Name"
                    required
                    style="width: 50% !important; margin-right: 0"
                  />
                  <input
                    v-model="lastName"
                    class="form-control"
                    type="text"
                    placeholder="Last Name"
                    required
                    style="width: 50% !important; margin-right: 0"
                  />
                </div>

                <!-- Email Address -->
                <input
                  v-model="email"
                  class="form-control"
                  type="email"
                  placeholder="Email Address"
                  required
                  style="margin-top: 10px; width: 100% !important"
                />
                <input
                  v-model="username"
                  class="form-control"
                  type="tel"
                  placeholder="User Name"
                  required
                  style="margin-top: 10px; width: 100% !important"
                />
                <!-- Password & Confirm Password -->
                <div class="d-flex" style="gap: 10px; margin-top: 10px">
                   <input
                      v-model="password"
                      autocomplete="new-password"
                      class="form-control"
                      type="password"
                      placeholder="Password"
                      required
                      :class="{ 'is-invalid': passwordTouched && !isPasswordValid }"
                      @blur="passwordTouched = true"
                      style="width: 50% !important;"
                    />
                    <input
                      v-model="confirmPassword"
                      class="form-control"
                      autocomplete="new-password"
                      type="password"
                      placeholder="Confirm Password"
                      required
                      :class="{ 'is-invalid': confirmPasswordTouched && !isPasswordMatch }"
                      @blur="confirmPasswordTouched = true"
                      style="width: 50% !important;"
                    />
                </div>
                <small v-if="passwordTouched && !isPasswordValid" class="text-danger">
                    Password must be at least 8 characters long and include a number.
                </small>
                <small v-if="confirmPasswordTouched && !isPasswordMatch" class="text-danger">
                  Passwords do not match.
                </small>

                <!-- Phone Number -->
                <input
                  v-model="phone"
                  class="form-control"
                  type="tel"
                  placeholder="Phone Number"
                  required
                  :class="{ 'is-invalid': phoneTouched && !isPhoneValid }"
                  @blur="phoneTouched = true"
                  style="margin-top: 10px; width: 100% !important;"
                />
                <small v-if="phoneTouched && !isPhoneValid" class="text-danger">
                  Please enter a valid phone number (e.g., +1234567890).
                </small>

                <!-- Common Fields -->
                <select
                  v-model="language"
                  class="form-control"
                  required
                  style="margin-top: 10px; width: 100% !important"
                >
                  <option value="" disabled selected>Primary Language</option>
                  <option value="English">English</option>
                  <option value="French">French</option>
                  <option value="Other">Other</option>
                </select>

                <!-- Student-Specific Fields -->
                <template v-if="!isTeacher">
                  <input
                    v-model="city"
                    class="form-control"
                    type="text"
                    placeholder="City"
                    required
                    style="margin-top: 10px; width: 100% !important"
                  />
                  <select
                    v-model="province"
                    class="form-control"
                    required
                    style="margin-top: 10px; width: 100% !important"
                  >
                    <option value="" disabled selected>Select Province</option>
                    <option value="AB">Alberta</option>
                    <option value="BC">British Columbia</option>
                    <option value="MB">Manitoba</option>
                    <option value="NB">New Brunswick</option>
                    <option value="NL">Newfoundland and Labrador</option>
                    <option value="NS">Nova Scotia</option>
                    <option value="ON">Ontario</option>
                    <option value="PE">Prince Edward Island</option>
                    <option value="QC">Quebec</option>
                    <option value="SK">Saskatchewan</option>
                    <option value="NT">Northwest Territories</option>
                    <option value="NU">Nunavut</option>
                    <option value="YT">Yukon</option>
                    <!-- Other provinces... -->
                  </select>
                </template>

                <!-- Teacher-Specific Fields -->
                <template v-if="isTeacher">
                  <input
                    v-model="title"
                    class="form-control"
                    type="text"
                    placeholder="Professional Title"
                    required
                    style="margin-top: 10px; width: 100% !important"
                  />
                  <input
                    v-model="education"
                    class="form-control"
                    type="text"
                    required
                    placeholder="Education"
                    style="margin-top: 10px; width: 100% !important"
                  />
                  <input
                    v-model="experience"
                    class="form-control"
                    type="number"
                    placeholder="Years of experience"
                    required
                    style="margin-top: 10px; width: 100% !important"
                  />
                  <input
                    v-model="experties"
                    class="form-control"
                    type="text"
                    placeholder="Areas of Expertise (comma separated)"
                    style="margin-top: 10px; width: 100% !important"
                  />
                  <textarea
                    v-model="bio"
                    class="form-control"
                    placeholder="Bio"
                    required
                    rows="4"
                    style="margin-top: 10px; width: 100% !important"
                ></textarea>
                </template>
              </div>

              <!-- Submit Button -->
              <input 
                type="submit" 
                class="btn ss-btn login-btn" 
                :value="isTeacher ? 'Apply as Instructor' : 'Create Student Account'" 
                style="width: 100% !important" 
              />
            </form>

            <div style="margin-top: 6px">
              Already have an account?
              <router-link to="/login">Login</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'Signup',
  data() {
    return {
      isTeacher: false,
      // Common fields
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: '',
      username:'',
      phone: '',
      language: '',
      bio: '',
      // Student fields
      city: '',
      province: '',
      // Teacher fields
      title: '',
      education:'',
      experience: null,
      experties: '',
    };
  },
  computed: {
    isPasswordValid() {
      // Password must be at least 8 chars and include a number
      return /^(?=.*[0-9]).{8,}$/.test(this.password);
    },
    isPasswordMatch() {
      return this.password === this.confirmPassword;
    },
    isPhoneValid() {
      // Basic international phone regex, adjust as needed
      return /^\+?[1-9]\d{7,14}$/.test(this.phone);
    },
  },
  methods: {
    async handleSignup() {
      try {
        // Validate passwords match
        if (this.password.trim() !== this.confirmPassword.trim()) {
          alert("Passwords don't match!");
          return;
        }

        const payload = {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          password: this.password,
          phone: this.phone,
          language: this.language,
          username: this.username,
          role: this.isTeacher ? 'teacher' : 'student'
        };
        let response;
        // Add role-specific fields
        if (this.isTeacher) {
          Object.assign(payload, {
            bio:this.bio,
            title: this.title,
            experience: this.experience,
            experties: this.experties,
            education: this.education
          });
          response = await api.post('/auth/signup/teacher', payload);
         
        } else {
          Object.assign(payload, {
            city: this.city,
            province: this.province
          });
          response = await api.post('/auth/signup', payload);
        }

        const { token } = response.data;
        localStorage.setItem('userToken', token);

        // Redirect to appropriate dashboard
        this.$router.push(this.isTeacher ? '/dashboard/courses' : '/dashboard/mycourses');
      } catch (error) {
        console.error('Signup failed:', error.response?.data?.message || error.message);
        alert(error.response?.data?.message || 'Registration failed. Please try again.');
      }
    }
  }
};
</script>

<style scoped>
/* Role toggle styles */
.role-toggle {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.is-invalid {
  border-color: red !important;
}

.toggle-label {
  margin-right: 15px;
  font-weight: 500;
  color: #333;
}

.toggle-switch {
  display: flex;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.toggle-btn {
  padding: 8px 20px;
  border: none;
  background: #f0f0f0;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.toggle-btn.active {
  background: #001f3f;
  color: white;
}

.toggle-btn:first-child {
  border-radius: 6px 0 0 6px;
}

.toggle-btn:last-child {
  border-radius: 0 6px 6px 0;
}
</style>